"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _PurchaseButton = _interopRequireDefault(require("../components/PurchaseButton"));

var _GoodsActions = require("../actions/GoodsActions");

var _auth = require("../selectors/auth");

var _goodDetails = require("../selectors/goodDetails");

var _withUsageTracking = _interopRequireDefault(require("./hocs/withUsageTracking"));

var _redux = require("redux");

var mapStateToProps = function mapStateToProps(state) {
  return {
    goodId: state.goodDetails.get('goodId'),
    goodName: state.goodDetails.get('goodName'),
    goodSubType: state.goodDetails.get('subType'),
    hasContentAccess: (0, _auth.getHasContentAccess)(state),
    hasEmailFreeOrStarter: (0, _auth.getHasEmailFreeOrStarter)(state),
    hasInstallAccess: (0, _auth.getHasInstallAccess)(state),
    hasEmailAccess: (0, _auth.getHasEmailAccess)(state),
    isCustomer: (0, _auth.getIsCustomer)(state),
    isGoodProvider: (0, _goodDetails.getIsGoodProvider)(state),
    isEmailGood: (0, _goodDetails.getIsEmailGood)(state),
    isTrial: (0, _auth.getIsTrialPortal)(state),
    isFree: state.goodDetails.get('isFree'),
    isPurchased: !!state.goodDetails.get('transactionId'),
    newVersionAvailable: state.goodDetails.get('newVersionAvailable'),
    payWithStripe: state.goodDetails.get('stripeProvider'),
    portalName: (0, _auth.getPortalName)(state),
    price: state.goodDetails.get('price')
  };
};

var mapDispatchToProps = {
  purchaseGoodWithPaypal: _GoodsActions.purchaseGoodWithPaypal,
  purchaseGoodWithStripe: _GoodsActions.purchaseGoodWithStripe,
  reinstallGood: _GoodsActions.reinstallGood,
  triggerPurchaseErrorModalOpening: _GoodsActions.triggerPurchaseErrorModalOpening
};

var _default = (0, _redux.compose)((0, _withUsageTracking.default)(), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(_PurchaseButton.default);

exports.default = _default;
module.exports = exports.default;